import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
export function ExternalLink(t0) {
  const $ = _c(11);
  let children;
  let href;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      href,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = rest;
  } else {
    children = $[1];
    href = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== href) {
    t1 = children ?? href?.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
    $[4] = children;
    $[5] = href;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== href || $[8] !== rest || $[9] !== t1) {
    t2 = <a href={href} {...rest}>{t1}</a>;
    $[7] = href;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}